import { render, staticRenderFns } from "./HeatmapCoords.vue?vue&type=template&id=47831c4e"
import script from "./HeatmapCoords.vue?vue&type=script&lang=js"
export * from "./HeatmapCoords.vue?vue&type=script&lang=js"
import style0 from "./HeatmapCoords.vue?vue&type=style&index=0&id=47831c4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports